let authToken = localStorage.getItem('authToken') || null;

export const setAuthToken = (token, data) => {
  const utf8EncodeText = new TextEncoder();
  const authTokenArray = utf8EncodeText.encode(token);
  localStorage.setItem('authToken', authTokenArray);
  
  // Storing UserId into LS
  const userIdArray = utf8EncodeText.encode(data.id);
  localStorage.setItem('userId', userIdArray);

  const roleArray = utf8EncodeText.encode(data.role);
  localStorage.setItem('role', roleArray);
};

export const getAuthToken = () => authToken;

export const getUserRole = () => {
  const numberArray = localStorage.getItem("role")?.split(",").map(Number);
const arrayBuffer = new Uint8Array(numberArray).buffer;
const userRole = new TextDecoder().decode(arrayBuffer);
  if (userRole) {
    return userRole;
  }
  return null;
};

export const clearAuthToken = () => {
  authToken = null;
  window.localStorage.clear();
  window.localStorage.removeItem('persist:*');
  window.location.replace('/login');
};